import { EDeviceType } from '../types';

/**
 * Default device type
 */
export const HEATMAP_DEVICE_CONFIG = {
  DEVICE_TYPE: EDeviceType.Desktop,
};
